import React, { Component } from 'react'
import IntractionActionsList from '../IntractionActionsList'
import StagesManager from '../StagesManager'
import FixedView from '../FixedView'
import { checkPermission, translate } from '../../utils/useful'
import importedIcons from '../inputs/icons'

export default class SelectMenu extends Component {


    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }


    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.settingView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('tools.Select')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.settingView = el} nodeRef={this.setting} xOffset={this.props.isMobile ? (this.props.language == 'fa' ? 215 : 120) : (this.props.language == 'fa' ? 215 : -10)} bottomOffset={0} topOffset={0} maxWidth={200} >
                    <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    <IntractionActionsList onClick={() => { this.props.functionsHandler('collectionView', 'openAddRelevantCollection') }} language={this.props.language} data={{ title: "{{lang}}tools.Add relevant collection", icon: importedIcons.addCollection }} />
                                    <IntractionActionsList onClick={() => { }} language={this.props.language} data={{ title: "{{lang}}tools.Publish applet", icon: importedIcons.invitations }} />
                                    <IntractionActionsList onClick={() => { }} language={this.props.language} data={{ title: "{{lang}}tools.Invitation", icon: importedIcons.invitations }} />
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
